import moment from '../../../lib/moment.js'
import shortid from 'shortid'
import find from 'lodash/find'
import get from 'lodash/get'
import findIndex from 'lodash/findIndex'
import orderBy from 'lodash/orderBy'
import uniq from 'lodash/uniq'
import groupBy from 'lodash/groupBy'
import * as CONSTANTS from '../constants'

function generateDays(momentStart, momentEnd) {
  // create date items running from start to end
  const dates = []
  const run = moment(momentStart) // clone to run
  while (run.isBefore(momentEnd, 'day') || run.isSame(momentEnd, 'day')) {
    const snapshot = moment(run) // clone snapshot
    dates.push({ date: snapshot, hours: 0 })
    run.add(1, 'days')
  }
  return dates
}

export const getTableDates = (_moment, range = 'month') => {
  const date = _moment || moment()
  let startDate
  let endDate
  if (range === 'month') {
    startDate = moment(date).date(1)
    endDate = moment(date).date(date.daysInMonth())
  } else if (range === 'week') {
    startDate = moment(date).day(0)
    endDate = moment(date).day(6)
  } else {
    startDate = moment()
    endDate = moment()
  }
  return generateDays(startDate, endDate)
}

export const generateKeyProjects = (projects) => {
  shortid.characters('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@')
  projects.map(project => {
    const proj = project
    proj.key = shortid.generate()
    return proj
  })
  return projects
}

export const removeKeyProjects = (projects) => {
  projects.map(project => {
    const proj = project
    proj.tasks.map(task => {
      const t = task
      delete t.key
      return t
    })
    delete proj.key
    return proj
  })
  return projects
}

export const addProject = (projectID, projects, timesheet, selectedDate) => {
  const addedProject = []
  shortid.characters('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@')
  projectID.map(id => {
    const newProject = {
      key: shortid.generate(),
      project_id: id,
      approver_id: '',
      tasks: [
        {
          location_id: '',
          task_name: '',
          times: generateDays(moment(selectedDate).startOf('month'), moment(selectedDate).endOf('month')),
        },
      ],
    }
    addedProject.push(newProject)
    return newProject
  })
  return [...timesheet.projects, ...addedProject]
}

export const addTask = (month) => {
  return {
    location_id: '',
    task_name: '',
    times: getTableDates(moment(month)),
  }
}

export const createApproverList = (list) => {
  /* eslint no-underscore-dangle: 0 */
  const approvers = []
  if (list) {
    list.map(approver => {
      approvers.push({
        label: `${approver.first_name} ${approver.last_name} (${approver.nick_name})`,
        value: approver._id,
        first_name: approver.first_name,
        last_name: approver.last_name,
        nick_name: approver.nick_name,
      })
      return approver
    })
    return orderBy(approvers, ['first_name', 'last_name', 'nick_name'], ['asc', 'asc', 'asc'])
  }
  return []
}

export const createLOBList = (list) => {
  /* eslint no-underscore-dangle: 0 */
  const lobs = [{ label: 'All', value: 'ALL_LOB' }]
  if (list) {
    list.map(lob => {
      lobs.push({
        label: lob.name,
        value: lob._id,
      })
      return lob
    })
    return lobs
  }
  return []
}

export const createLocationList = (list) => {
  const locations = []
  list.map(location => {
    locations.push({
      code: location.location_code,
      label: `${location.location_code} - ${location.name}`,
      value: location._id,
    })
    return location
  })
  return locations
}

export const findProject = (id, projects) => {
  const project = find(projects, { _id: id })
  if (project) return project
  return {}
}

export const addEmptyTask = (projects, date) => {
  projects.map(project => {
    const proj = project
    proj.tasks = [...proj.tasks, addTask(date)]
    return proj
  })
  return projects
}

export const checkHasLeaveRequest = (requests, time) => {
  for (let i = 0; i < requests.length; i++) {
    for (let j = 0; j < requests[i].dates.length; j++) {
      if (moment(requests[i].dates[j]).format('YYYY-MM-DD') === moment(time.date).format('YYYY-MM-DD')) {
        return requests.filter((req) => req.dates.includes(requests[i].dates[j])) // requests[i]
      }
    }
  }
  return false
}

export const checkHasCompensateRequest = (requests, time, project) => {
  for (let i = 0; i < requests.length; i++) {
    for (let j = 0; j < requests[i].dates.length; j++) {
      if (moment(requests[i].dates[j]).format('YYYY-MM-DD') === moment(time.date).format('YYYY-MM-DD')
      && project.project_id === requests[i].project_id) {
        return requests.filter((req) => req.dates.includes(requests[i].dates[j])) // requests[i]
      }
    }
  }
  return false
}

export const removeEmptyTask = (projects, leaveRequests, compensateRequests, holidays) => {
  projects.map(project => {
    project.tasks.map(task => {
      task.times.map(time => {
        const hasLeave = checkHasLeaveRequest(leaveRequests, time)
        const newTime = time
        if ((hasLeave.length === 1 && hasLeave[0].leave_time === 'FULLDAY')
        || hasLeave.length > 1) {
          newTime.hours = 0
        }
        // const isWeekend = moment(time.date).day() === 0 || moment(time.date).day() === 6
        // const isHoliday = find(holidays, { date: (moment(time.date).format('YYYY-MM-DD')) })
        // const hasCompensate = checkHasCompensateRequest(
        //   compensateRequests, time, project)
        // if ((isHoliday && !hasCompensate) || (isWeekend && !hasCompensate)) {
        //   newTime.hours = 0
        // }
        return newTime
      })
      return task
    })
    return project
  })
  return projects.map(({ approver_id, tasks, project_id }) => {
    return {
      approver_id, tasks, project_id,
    }
  })
}

export const changeFormatDate = (dates) => {
  dates.map(date => {
    const d = date
    d.date = moment(date.date).format('YYYY-MM-DD')
    return d
  })
  return dates
}

export const calculateTotalHours = (e, timeID, myTimesheet,
  maximumWorkingHoursPerDay, setTotalHours) => {
  let sum = 0
  let maximum = []
  myTimesheet.timesheet.projects.map(project => {
    project.tasks.map(task => {
      return sum += parseFloat(task.times[timeID].hours)
    })
    return project
  })
  Object.keys(maximumWorkingHoursPerDay).forEach(s => {
    maximum.push({ date: s, hours: maximumWorkingHoursPerDay[s].hours })
  })
  maximum = orderBy(maximum, ['date'], 'asc')
  setTotalHours(sum)
  return sum > maximum[timeID].hours
}

export const setInvalidInput = (exceed, taskID, timeID, invalidList) => {
  let list = [...invalidList]
  const time = moment(timeID).format('YYYY-MM-DD')
  const exist = invalidList.find(i => i.timeID === time)
  if (exceed) {
    if (exist === undefined) {
      list = [...list, { timeID: time }]
    }
  } else if (exist) {
    const index = invalidList.findIndex(i => i.timeID === time)
    list.splice(index, 1)
  }
  return list
}

export const reCalculateTotalHours = (myTimesheet, maximumWorkingHoursPerDay,
  setTotalHoursValue, setInvalid, invalidList) => {
  let tempInvalidList = invalidList
  myTimesheet.timesheet.projects[0].tasks.map((task, taskID) => {
    task.times.map((time, timeID) => {
      const date = myTimesheet.timesheet.projects[0].tasks[taskID].times[timeID].date
      const exceed = calculateTotalHours('', timeID, myTimesheet,
        maximumWorkingHoursPerDay, (value) => setTotalHoursValue(time, value))
      const newInvalidList = setInvalidInput(exceed, taskID, date, tempInvalidList)
      tempInvalidList = newInvalidList
      return time
    })
    setInvalid(tempInvalidList)
    return task
  })
  return myTimesheet
}

export const createProjectList = (projects) => {
  const list = []
  projects.map(project => {
    list.push({ label: `${project.project_code} - ${project.name}`, value: project._id })
    return project
  })
  return list
}

export const filterProjects = (selectedRadioAddProject, projects, e) => {
  let filteredProjects = projects
  switch (selectedRadioAddProject) {
    case 2:
      filteredProjects = projects.filter((element) => {
        return ['FIXFEE', 'TIME_MATERIAL', 'SUPPORT'].includes(element.project_type)
      })
      break
    case 3:
      filteredProjects = projects.filter((element) => {
        return ['COMMON', 'SPECIFIC'].includes(element.project_type)
      })
      break
    default:
      break
  }
  if (e) {
    filteredProjects = filteredProjects.filter((element) => {
      const name = element.name.toLowerCase()
      const code = (element.project_code === undefined) ? '' : element.project_code.toLowerCase()
      const search = e.toLowerCase()
      return name.includes(search) || code.includes(search)
    })
  }
  return filteredProjects
}

export const copyTimesheet = (projectID, filteredTimesheets, timesheet, selectedDate) => {
  shortid.characters('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@')
  let tempIndex = ''
  const addedProject = []
  projectID.map(id => {
    const idx = id.split('-')
    const isExist = findIndex(addedProject, {
      project_id: idx[0],
      approver_id: idx[1],
      key: tempIndex,
    })
    const index = findIndex(filteredTimesheets, {
      project_id: idx[0],
      approver_id: idx[1],
      key: idx[2],
    })
    if (isExist > -1) {
      const tempTask = filteredTimesheets[index].tasks[idx[3]]
      addedProject[isExist].tasks = [
        ...addedProject[isExist].tasks,
        {
          location_id: tempTask.location_id,
          task_name: tempTask.task_name,
          times: generateDays(moment(selectedDate).startOf('month'), moment(selectedDate).endOf('month')),
        },
      ]
    } else {
      const tempProject = filteredTimesheets[index]
      const tempTask = tempProject.tasks[idx[3]]
      tempIndex = shortid.generate()
      const newProject = {
        key: tempIndex, // tempProject.key,
        project_id: tempProject.project_id,
        approver_id: tempProject.approver_id,
        tasks: [
          {
            location_id: tempTask.location_id,
            task_name: tempTask.task_name,
            times: generateDays(moment(selectedDate).startOf('month'), moment(selectedDate).endOf('month')),
          },
        ],
      }
      addedProject.push(newProject)
    }
    return id
  })
  return [...timesheet.projects, ...addedProject]
}

export const filterCopyTimesheet = (
  selectedRadioCopy, selectedDateCopy, timesheets, myProjects = [], searchCopy) => {
  shortid.characters('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@')
  let myProjectIDs = []

  myProjects.map(project => myProjectIDs.push(project._id))
  myProjectIDs = uniq(myProjectIDs)

  const date = selectedDateCopy ? moment(selectedDateCopy, 'MM-YY').format('YYYY-MM') : moment().format('YYYY-MM')
  let timesheetByMonth = get(timesheets, 'myTimesheets', []).filter(
    (element) => moment(element.month).format('YYYY-MM') === date)
  timesheetByMonth = get(timesheetByMonth, 'length') > 0 ? timesheetByMonth[0].projects : []
  timesheetByMonth = timesheetByMonth.filter((element) => myProjectIDs.includes(element.project_id))
  timesheetByMonth = groupBy(timesheetByMonth, 'project_id')

  let newTimesheet = []
  Object.keys(timesheetByMonth).forEach(idx => {
    timesheetByMonth[idx].forEach(project => {
      const proj = project
      if (proj.key === undefined) proj.key = shortid.generate()
      newTimesheet.push(proj)
    })
  })

  switch (selectedRadioCopy) {
    case 2:
      newTimesheet = newTimesheet.filter((element) => {
        const projectType = find(myProjects, { _id: element.project_id })
        return ['FIXFEE', 'TIME_MATERIAL', 'SUPPORT'].includes(projectType.project_type)
      })
      break
    case 3:
      newTimesheet = newTimesheet.filter((element) => {
        const projectType = find(myProjects, { _id: element.project_id })
        return ['COMMON', 'SPECIFIC'].includes(projectType.project_type)
      })
      break
    default:
      break
  }

  if (searchCopy) {
    newTimesheet = newTimesheet.filter((element) => {
      const project = find(myProjects, { _id: element.project_id })
      const name = get(project, 'name', '').toLowerCase()
      const code = get(project, 'project_code', '').toLowerCase()
      const search = searchCopy.toLowerCase()
      if (name.includes(search) || code.includes(search)) return true
      let tasks = element.tasks
      tasks = tasks.filter(task => {
        const task_name = task.task_name.toLowerCase()
        return task_name.includes(search)
      })
      if (tasks.length > 0) return true
      return false
    })
  }

  // Object.keys(timesheetByMonth).forEach(key => {
  //   const tempProject = {}
  //   const tempTasks = []
  //   tempProject.project_id = key
  //   timesheetByMonth[key].forEach(project => {
  //     tempTasks.push(...get(project, 'tasks', []))
  //   })
  //   tempProject.tasks = tempTasks
  //   newTimesheet.push(tempProject)
  // })
  return newTimesheet
}

export const generateSumHoursByDate = (dates) => {
  const sumHoursByDate = []
  dates.map(date => {
    const key = moment(date).format('YYYY-MM-DD')
    sumHoursByDate[key] = 0
    return date
  })
  return sumHoursByDate
}

export const findUserData = (id, users) => {
  let data
  users.map(user => {
    data = find(users, { _id: id })
    return user
  })
  return data
}

export const checkInvalidApprover = (projects) => {
  const invalid = projects.filter((element) => {
    return element.approver_id === '' || element.approver_id === undefined
  })
  return invalid.length > 0
}

export const filterProjectsFillHours = (myProjects, projects, selectedType, searchFillHours) => {
  shortid.characters('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@')
  let myNewProjects = myProjects
  myNewProjects = myNewProjects.map(project => {
    get(project, 'tasks', []).map(task => {
      const newTask = task
      newTask.key = shortid.generate()
      return newTask
    })
    return project
  })

  switch (selectedType) {
    case 2:
      myNewProjects = myNewProjects.filter((element) => {
        const projectType = find(projects, { _id: element.project_id })
        return [
          CONSTANTS.FIXFEE, CONSTANTS.TIME_MATERIAL, CONSTANTS.SUPPORT,
        ].includes(projectType.project_type)
      })
      break
    case 3:
      myNewProjects = myNewProjects.filter((element) => {
        const projectType = find(projects, { _id: element.project_id })
        return [
          CONSTANTS.COMMON, CONSTANTS.SPECIFIC,
        ].includes(projectType.project_type)
      })
      break
    default:
      break
  }

  if (searchFillHours) {
    myNewProjects = myNewProjects.filter((element) => {
      const project = find(projects, { _id: element.project_id })
      const name = get(project, 'name', '').toLowerCase()
      const code = get(project, 'project_code', '').toLowerCase()
      const search = searchFillHours.toLowerCase()
      // search by project name & task name
      if (name.includes(search) || code.includes(search)) return true
      let tasks = element.tasks
      tasks = tasks.filter(task => {
        const task_name = task.task_name.toLowerCase()
        return task_name.includes(search)
      })
      if (tasks.length > 0) return true
      return false
    })
  }

  return myNewProjects
}

export const fillHoursTimesheet = (sumHoursByDate, checkedTask, myTimesheet,
  selectedStartDate, selectedEndDate, remainHours, specificHours, isSubcontract) => {
  const maximumWorkingHoursPerDay = get(myTimesheet, 'maximumWorkingHoursPerDay', {})
  const compensateRequests = get(myTimesheet, 'compensateRequests', [])
  const idx = checkedTask.split('^')
  // find project by project_id & task name
  const projectIndex = findIndex(myTimesheet.timesheet.projects, (element) => {
    const validProjectID = element.project_id === idx[0]
    const validApproverID = element.approver_id === idx[1]
    const validKey = element.key === idx[2]
    const validTask = find(element.tasks, (task => {
      return (task.task_name).localeCompare(idx[4]) === 0
    }))
    return validProjectID && validApproverID && validKey && validTask
  })
  const project = myTimesheet.timesheet.projects[projectIndex]
  const task = project.tasks[parseInt(idx[3], 10)]
  const run = moment(selectedStartDate)

  while (run.isBefore(selectedEndDate, 'day') || run.isSame(selectedEndDate, 'day')) {
    const date = moment(run).format('YYYY-MM-DD')
    const filteredIndex = findIndex(task.times, (element) => {
      return moment(element.date).format('YYYY-MM-DD') === date
    })
    if (remainHours) {
      const maximum = maximumWorkingHoursPerDay[date].hours
      const sum = sumHoursByDate[date]
      const remain = (maximum - sum < 0) ? 0 : (maximum - sum)
      const isWeekEnd = moment(date).day() === 0 || moment(date).day() === 6
      const hasCompensate = find(compensateRequests, (compensate) => {
        return find(compensate.dates, (d) => {
          return moment(d).format('YYYY-MM-DD') === date && compensate.project_id === idx[0]
        })
      })
      if (isWeekEnd && !isSubcontract && !hasCompensate) {
        task.times[filteredIndex].hours = 0
      } else {
        task.times[filteredIndex].hours = parseFloat(task.times[filteredIndex].hours) + remain
      }
    } else {
      const maximum = maximumWorkingHoursPerDay[date].hours
      const isWeekEnd = moment(date).day() === 0 || moment(date).day() === 6
      const hasCompensate = find(compensateRequests, (compensate) => {
        return find(compensate.dates, (d) => {
          return moment(d).format('YYYY-MM-DD') === date && compensate.project_id === idx[0]
        })
      })
      if (isWeekEnd && !isSubcontract && !hasCompensate) {
        task.times[filteredIndex].hours = 0
      } else {
        task.times[filteredIndex].hours = maximum > 0 ? specificHours : 0
      }
    }
    run.add(1, 'days')
  }

  const newTimesheet = myTimesheet.timesheet.projects
  newTimesheet[projectIndex].tasks[idx[1]] = task

  return newTimesheet
}



// WEBPACK FOOTER //
// ./src/components/timesheet/helpers/timesheet.js